module.exports = __webpack_public_path__ + "static/img/btn-bg1.6dc32f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn-bg1.png
// module id = V0dD
// module chunks = 7